import type { TSelectItem } from '../../types';
import { callOnce } from '../callOnce';
import { TRACKED_ACTIONS } from './constants';
import { trackAction } from './sendEvent';

export const trackingHandle = {
  downloadLinks: {
    // being sent if audiotracks fetch failed
    onLinksRetryRendered: callOnce(() =>
      trackAction(TRACKED_ACTIONS.DOWNLOAD_LINKS_RENDERED_RETRY_UI),
    ),
    // final step of "retry" flow for DL links.
    userRetriesGetLinks: (context: { audiotrackUri?: string }) =>
      trackAction(TRACKED_ACTIONS.USER_RETRIES_GET_LINKS, context),
  },
  audioTrackSelector: {
    // being sent if number of fetched alternate audiotracks > 0
    onSelectorUIRendered: callOnce(() =>
      trackAction(TRACKED_ACTIONS.AUDIOTRACKS_SELECTOR_RENDERED_UI),
    ),
    // being sent if alternate audiotracks fetch failed
    onSelectorRetryRendered: callOnce(() =>
      trackAction(TRACKED_ACTIONS.AUDIOTRACKS_SELECTOR_RENDERED_RETRY_UI),
    ),
    userSelectedAudioTrack: (context: TSelectItem) =>
      trackAction(TRACKED_ACTIONS.USER_SELECTED_AUDIOTRACK, context),
    // final step of "retry" flow for audio tracks.
    userRetriesGetAudiotracks: () => trackAction(TRACKED_ACTIONS.USER_RETRIES_GET_AUDIOTRACKS),
    userOpenAudiotracksPopover: callOnce(() =>
      trackAction(TRACKED_ACTIONS.OPEN_AUDIOTRACKS_POPOVER),
    ),
    userCloseAudiotracksPopover: callOnce(() =>
      trackAction(TRACKED_ACTIONS.CLOSE_AUDIOTRACKS_POPOVER),
    ),
  },
};
